import Route from '@ember/routing/route';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';

export default class RegistrationRoute extends Route {
  mainLayout = MainLayout;

  async model() {
    let registration = this.modelFor('registration');
    let organization = await registration.get('organization');
    return { registration, organization };
  }
}
